export default {"src":"/_next/static/media/right-arrow-icobn.97e28356.svg","height":10,"width":31,"blurWidth":0,"blurHeight":0};